'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ReactDOM = require('react-dom');

const root = require('bunsen/helpers/windowCheck');
const { noop } = require('../../global/mixins/commonjs/basicUtils');
const { SwipeDetector } = require('../../global/utils/touch');
const PinchZoomComponent = require('../../global/components/PinchZoomComponent');

const styles = require('./GalleryPhotoContainer-style.scss');

class GalleryPhotoContainer extends React.Component {
    constructor(props) {
        super(props);

        this._onKeyDown = this._onKeyDown.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onSwipe = this._onSwipe.bind(this);
        this._onZoomIn = this._onZoomIn.bind(this);
        this._onZoomOut = this._onZoomOut.bind(this);
    }

    componentDidMount() {
        this.enableSwipe();
        this.enableArrowNavigation();
    }

    componentWillUnmount() {
        this.disableArrowNavigation();
    }

    enableArrowNavigation() {
        root.addEventListener('keydown', this._onKeyDown);
    }

    disableArrowNavigation() {
        root.removeEventListener('keydown', this._onKeyDown);
    }

    enableSwipe() {
        if (!this._swipeDetector && this.props.allowTouchEvents) {
            this._swipeDetector = new SwipeDetector({
                el: ReactDOM.findDOMNode(this._pz),
                onSwipeSuccess: this._onSwipe,
            });
        }
    }

    disableSwipe() {
        if (this._swipeDetector) {
            this._swipeDetector.destroy();
            this._swipeDetector = undefined;
        }
    }

    _onKeyDown(e) {
        const { keyCode, keyIdentifier, key } = e;

        if (keyIdentifier === 'Right' || key === 'Right' || keyCode === 39) {
            this.props.next(this.props.photoData);
        } else if (keyIdentifier === 'Left' || key === 'Left' || keyCode === 37) {
            this.props.prev(this.props.photoData);
        }
    }

    _onClick(e) {
        if (e.currentTarget && e.currentTarget.getBoundingClientRect) {
            const { right, left } = e.currentTarget.getBoundingClientRect();

            if ((right + left) / 2 > e.pageX) {
                this.props.prev(this.props.photoData);
            } else {
                this.props.next(this.props.photoData);
            }
        }
    }

    _onSwipe(direction) {
        direction.match({
            left: () => this.props.next(this.props.photoData),
            right: () => this.props.prev(this.props.photoData),
        });
    }

    _onZoomIn() {
        this.disableSwipe();
        this.props.zoomIn(this.props.photoData);
    }

    _onZoomOut() {
        this.enableSwipe();
        this.props.zoomOut(this.props.photoData);
    }

    render() {
        if (this.props.allowTouchEvents) {
            return (
                <PinchZoomComponent
                    ref={el => {
                        this._pz = el;
                    }}
                    className={styles.container}
                    onZoomIn={this._onZoomIn}
                    onZoomOut={this._onZoomOut}
                >
                    {this.props.children}
                </PinchZoomComponent>
            );
        } else {
            return (
                <div className={styles.container} onClick={this._onClick}>
                    {this.props.children}
                </div>
            );
        }
    }
}

GalleryPhotoContainer.propTypes = {
    next: PropTypes.func,
    prev: PropTypes.func,
    zoomIn: PropTypes.func,
    zoomOut: PropTypes.func,

    photoData: PropTypes.object,
    allowTouchEvents: PropTypes.bool,

    children: PropTypes.array.isRequired,
};

GalleryPhotoContainer.defaultProps = {
    next: noop,
    prev: noop,
    zoomIn: noop,
    zoomOut: noop,
    allowTouchEvents: false,
};

module.exports = GalleryPhotoContainer;



// WEBPACK FOOTER //
// ./assets/js/gallery/components/GalleryPhotoContainer.jsx